<template>
    <routerView></routerView>
</template>

<script>
    import storeLoader from "./utils/storeLoader";

    export default {
        name: "App",
        data: function () {
            return {
                sites: []
            }
        },
        mounted() {
            if (this.$store.state.token !== undefined) {
                 storeLoader.load();
             }
        }
    }
</script>

<style lang="scss">
    @import '~bootstrap/scss/_functions';
    @import '~bootstrap/scss/_variables';
    @import '~bootstrap/scss/mixins/_breakpoints';

    .container-fluid {
        @include media-breakpoint-down(sm) {
            padding-right: 5px;
            padding-left: 5px;
        }
    }
</style>